// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__1asao","signatureButtonsRight":"ModalSign_signatureButtonsRight__3TNfk"};